import { getSizeCodeTypeString, SizeCode } from 'entities/SizeCode';

export const getSelectedSizesLabel = (sizeCodes: SizeCode[]): string => {
  return [...sizeCodes]
    .sort((a, b) => a.square - b.square)
    .map((sizeCode) => `${sizeCode.square} ${getSizeCodeTypeString(sizeCode.sizeCodeType)}`)
    .join(', ');
};
